document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("cart__up_min");
  if (!container) return;

  const items = container.querySelectorAll(".upsell-card__cartsmall");
  if (items.length === 0) return;

  // Paramètres du carrousel
  const visibleCount = 3; // nombre d'articles visibles à la fois
  const slideSpeed = 3000; // durée entre les défilements (ms)
  let currentIndex = 0;
  let autoSlide;

  // Styles nécessaires
  container.style.display = "flex";
  container.style.overflow = "hidden";
  container.style.scrollBehavior = "smooth";

  items.forEach(item => {
    item.style.minWidth = `${100 / visibleCount}%`;
    item.style.boxSizing = "border-box";
  });

  function slideNext() {
    currentIndex++;
    if (currentIndex > items.length - visibleCount) {
      currentIndex = 0;
    }
    const scrollAmount = container.clientWidth * (currentIndex / visibleCount);
    container.scrollTo({
      left: scrollAmount,
      behavior: "smooth"
    });
  }

  function startAutoSlide() {
    autoSlide = setInterval(slideNext, slideSpeed);
  }

  function stopAutoSlide() {
    clearInterval(autoSlide);
  }

  // Démarrer le carrousel
  startAutoSlide();

  // Pause au survol
  //container.addEventListener("mouseenter", stopAutoSlide);
  container.addEventListener("mouseleave", startAutoSlide);
});
6